import { ButtonPrimeReact } from "@finanedi.es/storybook"
import FormikDropdown from "common/components/FormikFields/FormikDropdown"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import * as Validations from "common/utils/formValidations"
import {
  FORMAS_DE_CONTACTO,
  FORMAS_DE_CONTACTO_REV,
  OPTIONS_FORMAS_CONTACTO,
} from "features/Contactos/constants"
import { withFormik } from "formik"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"

const FormaContactoForm = ({
  values,
  handleSubmit,
  onHide,
  isEditing,
  isValid,
  dirty,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <form
      onSubmit={handleSubmit}
      className='tw-w-full tw-flex tw-flex-col'
    >
      <div className='tw-w-full'>
        <div className='tw-mb-4'>
          <label htmlFor='tipoFormaContacto'>
            {t("contactos.editar.modal.labelType")}
          </label>

          <FormikDropdown
            placeholder={`${t(
              "contactos.editar.modal.placeholderNewContactType"
            )}`}
            options={OPTIONS_FORMAS_CONTACTO(t)}
            value={values.tipoFormaContacto}
            name='tipoFormaContacto'
            className='tw-rounded-none tw-w-full'
          />
        </div>
      </div>

      <div className='tw-w-full'>
        <div className='tw-mb-4'>
          <label htmlFor='contacto'>
            {values?.tipoFormaContacto === -1
              ? `${t("contactos.editar.modal.labelContat")}`
              : // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
                FORMAS_DE_CONTACTO_REV[values?.tipoFormaContacto]}
          </label>

          <FormikInputText
            id='contacto'
            name='contacto'
            className='tw-w-full'
          />
        </div>
      </div>

      <div className='tw-mt-1 tw-w-full tw-flex tw-justify-end'>
        <ButtonPrimeReact
          className='tw-mr-4 !tw-bg-white !tw-text-primary !tw-border-none'
          onClick={onHide}
        >
          {t("contactos.editar.modal.cancelButton")}
        </ButtonPrimeReact>
        <ButtonPrimeReact
          className='!tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-none'
          type='submit'
          disabled={!(isValid && dirty)}
        >
          {isEditing
            ? `${t("contactos.editar.modal.saveButton")}`
            : `${t("contactos.editar.modal.addButton")}`}
        </ButtonPrimeReact>
      </div>
    </form>
  )
}

const CONTACTO_VALIDATIONS = (t: $TSMigrationFixMe) => {
  return {
    [FORMAS_DE_CONTACTO.EMAIL]: Validations.validateEmail(t),
    [FORMAS_DE_CONTACTO.MOVIL]: Validations.validateMovil(t),
    [FORMAS_DE_CONTACTO.TELEFONO]: Validations.validateTelefono(t),
    [FORMAS_DE_CONTACTO.FAX]: Validations.validateFax(t),
    [FORMAS_DE_CONTACTO.WEB]: Validations.validateWeb(t),
  }
}

export const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    tipoFormaContacto: Yup.number().oneOf(
      Object.values(FORMAS_DE_CONTACTO),
      t("errors.selectClientType")
    ),
    contacto: Yup.string()
      .required(t("errors.contactEmpty"))
      .ensure()
      .when("tipoFormaContacto", (tipoFormaContacto) => {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
        return CONTACTO_VALIDATIONS[tipoFormaContacto]
      }),
  })

const Form = withFormik({
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'data' does not exist on type '{}'.
  mapPropsToValues: ({ data }) => {
    return {
      id: data?.id || "",
      empresaId: data?.empresaId || "",
      tipoFormaContacto: data?.tipoFormaContacto,
      contacto: data?.contacto || "",
      nombre: data?.nombre || "",
      principal: data?.principal || false,
    }
  },
  enableReinitialize: true,
  validationSchema: ({ t }: $TSMigrationFixMe) => validationSchema(t),
  handleSubmit: async (values, { props }) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { empresaId, ...editPayload } = values
    // @ts-expect-error TS(2339): Property 'updateData' does not exist on type 'obje...
    props.updateData(props.isEditing ? editPayload : values)
  },
})(FormaContactoForm)

export default Form
